var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RouterLink',{attrs:{"to":_vm.routerLink}},[_c('div',{staticClass:"card is-full-height link-card"},[_c('div',{staticClass:"card-header is-full-height"},[_c('div',{staticClass:"card-header-title"},[_c('div',{staticClass:"title is-3 has-text-grey py-6 pl-2"},[_vm._t("default")],2)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }